import {
  AccessTime,
  CalendarToday,
  EventAvailable,
  EventBusy,
  LocationOn,
  Timer,
  TimerOff,
} from '@mui/icons-material';
import { Chip, Typography } from '@mui/material';
import { Box } from '@mui/system';
import {
  toDateRange,
  toReadableDateTimeString,
  toTimeRange,
} from '../../utils/dateFormatter';

const RaceOrRacepakInfo = ({
  label,
  location,
  start,
  end,
  isMobile,
  isRacepack,
  sports,
  isSubmit,
}) => {
  if (sports?.length > 0)
    return (
      <>
        <Typography
          variant={!isMobile ? 'h5' : 'h6'}
          component={'div'}
          fontWeight={'600'}
          style={{ marginTop: '1rem', marginBottom: '.5rem' }}
        >
          {label}
        </Typography>
        <Box
          display={'flex'}
          justifyContent={'flex-start'}
          alignItems={'center'}
          flexDirection={'row'}
        >
          {sports?.map((sport, idx) => (
            <Chip
              key={idx}
              label={sport.name}
              style={{
                marginRight: '10px',
                paddingInline: '4px',
                color: '#830000',
                backgroundColor: '#ffd3d3',
                marginBottom: '6px',
              }}
              sx={{
                height: { xl: '42px', md: '38px' },
                fontSize: { xl: '24px', md: '20px' },
              }}
            />
          ))}
        </Box>
      </>
    );

  if (isSubmit)
    return (
      <>
        <Typography
          variant={!isMobile ? 'h5' : 'h6'}
          component={'div'}
          fontWeight={'600'}
          style={{ marginTop: '1rem', marginBottom: '.5rem' }}
        >
          {'Submission Date'}
        </Typography>

        <Box
          display={'flex'}
          justifyContent={'flex-start'}
          alignItems={'center'}
          marginBottom={'.5rem'}
        >
          <EventAvailable fontSize="large" style={{ marginRight: '6px' }} />

          <Typography
            component={'div'}
            variant={!isMobile ? 'h6' : 'body2'}
            align="center"
            style={{ justifyContent: 'center', letterSpacing: '1px' }}
          >
            {toReadableDateTimeString(start)}
          </Typography>
        </Box>

        <Box
          display={'flex'}
          justifyContent={'flex-start'}
          alignItems={'center'}
        >
          <EventBusy fontSize="large" style={{ marginRight: '6px' }} />

          <Typography
            component={'div'}
            variant={!isMobile ? 'h6' : 'body2'}
            align="center"
            style={{ justifyContent: 'center', letterSpacing: '1px' }}
          >
            {toReadableDateTimeString(end)}
          </Typography>
        </Box>
      </>
    );

  return (
    <>
      <Typography
        variant={!isMobile ? 'h5' : 'h6'}
        fontWeight={'600'}
        component={'div'}
        style={{ marginTop: '1rem', marginBottom: '.5rem' }}
      >
        {label}
      </Typography>
      {location && (
        <Box
          display={'flex'}
          justifyContent={'flex-start'}
          alignItems={'center'}
        >
          <LocationOn fontSize="small" style={{ marginRight: '6px' }} />
          <Typography
            component={'div'}
            variant={!isMobile ? 'h6' : 'body2'}
            style={{ justifyContent: 'center' }}
          >
            {location}
          </Typography>
        </Box>
      )}

      <Box display={'flex'} justifyContent={'flex-start'} alignItems={'center'}>
        <CalendarToday fontSize="small" style={{ marginRight: '6px' }} />

        <Typography
          component={'div'}
          variant={!isMobile ? 'h6' : 'body2'}
          align="center"
          style={{ justifyContent: 'center', letterSpacing: '1px' }}
        >
          {toDateRange(start, end)}
        </Typography>
      </Box>

      <Box display={'flex'} justifyContent={'flex-start'} alignItems={'center'}>
        <AccessTime fontSize="small" style={{ marginRight: '6px' }} />

        <Typography
          component={'div'}
          variant={!isMobile ? 'h6' : 'body2'}
          align="center"
          style={{ justifyContent: 'center', letterSpacing: '1px' }}
        >
          {toTimeRange(start, end)}
        </Typography>
      </Box>
    </>
  );
};

export default RaceOrRacepakInfo;
